export default __webpack_public_path__ + "static/media/plus-circle.27666e43.svg";